import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement, ISelectFieldSingleItem } from '../Form/DynamicForm'
import { InputLabel, MenuItem, Select } from '@mui/material'
import { updateAllLocations, useReturnAllLocations } from '../../features/locations/locationsSlice'
import LocationsApp, { ILocationModel } from '../../features/locations/LocationsApp'
import Countries from '../../features/locations/Countrries'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { updateAllWarehouses, useReturnAllWarehouses } from '../../features/warehouses/warehousesSlice'
import WarehousesApp, { IWarehouseModel } from '../../features/warehouses/WarehousesApp'

export default function WarehouseSelectFieldElement(props: IBaseDynamicFormElement) {

    const dispatch = useDispatch()

    const { id, label, fullWidth, handleOnChange, data, addNoneItem } = props

    const items = useReturnAllWarehouses()
    const warehousesApp = new WarehousesApp()

    const [value, setValue] = useState<any>("")

    const labelId = "label_of_" + id

    const renderItems = () => {

        if (items && items.length > 0){
            return items.map((item: IWarehouseModel, index: number) => <MenuItem value={item.id} key={index}>{item.title}</MenuItem>)
        }
        
        return <></>
    }

    useEffect(() => {
        setValue(data.value)
    }, [data.value])

    useEffect(() => {

        warehousesApp.listOfInstances(1, "", true)
            .then(response => {

                const data = response.data
                dispatch(updateAllWarehouses(data))

            })
            .catch(error => {
                handleRequestError(error, dispatch)
            })

    }, [])

    return(
        <>
                <InputLabel id={labelId}>{label}</InputLabel>
                <Select
                    labelId={labelId}
                    id={id}
                    value={value}
                    label={label}
                    name={id}
                    onChange={(e) => handleOnChange(id, e.target.value)}
                    error={data.helperTextType === "error" ? true : false}
                    disabled={data.disabled}
                    fullWidth={fullWidth}
                >
                    {addNoneItem && <MenuItem value="">None</MenuItem>}
                    {renderItems()}
                </Select>
        </>
    )
}